<template>
  <span>
    <app-button
      v-if="showButton"
      data-qa="transfer-quote-establishment-button"
      @click="toggleModal(true)"
      >{{ i18n.t('/TransferQuote/TransferQuoteEstablishment') }}</app-button
    >

    <modal
      v-if="showModal"
      :title="i18n.t('/TransferQuote/TransferEstablishmentModalTitle')"
      @close="toggleModal(false)"
    >
      <loader v-if="isLoading" />

      <div v-else>
        <p>{{ i18n.t('/TransferQuote/TransferEstablishmentModalText') }}</p>

        <p>
          <select v-model="selectedEstablishment" name="establishments">
            <option value="0">Selecteer een vestiging</option>
            <option
              v-for="establishment in availableEstablishments"
              :key="establishment.value"
              :value="establishment.value"
            >
              {{ establishment.text }}
            </option>
          </select>
        </p>

        <div>
          <app-button data-qa="save-transfer-quote-button" @click="transferQuote">{{
            i18n.t('/Common/Save')
          }}</app-button>
        </div>
      </div>
    </modal>
  </span>
</template>

<script>
import quoteOrderService from '@/services/quoteOrderService'
import establishmentsService from '@/services/establishmentsService.js'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import StoreConnector from '@/helpers/StoreConnector'

export default {
  components: {
    AppButton,
    Loader,
    Modal,
  },
  props: {
    showButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLoading: false,
      hasOtherEmployee: false,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showModal: false,
      availableEstablishments: [],
      selectedEstablishment: 0,
    }
  },
  async mounted() {
    await establishmentsService.getEstablishments().then((response) => {
      this.isLoading = false
    })
    StoreConnector.get('establishments/availableEstablishments', (data) => {
      this.availableEstablishments = data
    })
  },
  methods: {
    async transferQuote() {
      this.isLoading = true

      await quoteOrderService.transferQuoteEstablishment(this.selectedEstablishment)

      this.isLoading = false
      this.toggleModal(false)
    },
    toggleModal(show) {
      this.showModal = show
    },
  },
}
</script>

<style></style>
